import { motion } from "framer-motion";
import { Activity, Shield } from "lucide-react";
import heroBg from "@/assets/hero-bg-digital-health.webp";
import ProcessFlow from "./ProcessFlow";
import { useTranslation } from "@/hooks/useTranslation";

const VidavoIcon = ({ className }: { className: string }) => (
  <img src="/lovable-uploads/3752ca2b-82c2-441c-8b94-dc49e1140fc2.png" alt="Vidavo" className={className} />
);

const Hero = () => {
  const { t } = useTranslation();
  return <header className="container-padding py-12 relative overflow-hidden min-h-screen flex items-center">
      {/* Dynamic Background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-25" style={{
        backgroundImage: `url(${heroBg})`,
        backgroundPosition: 'center center'
      }} />
        <div className="absolute inset-0 bg-gradient-to-br from-neutral-50/70 via-white/80 to-secondary/5" />
      </div>
      
      {/* Hero content */}
      <div className="max-w-5xl mx-auto text-center relative z-10">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8
      }} className="mb-8">
          <motion.span className="inline-flex items-center gap-2 bg-gradient-to-r from-secondary/10 to-accent-teal/10 
                       border border-secondary/20 rounded-full px-6 py-3 text-secondary font-medium
                       backdrop-blur-sm" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }}>
            <VidavoIcon className="w-4 h-4 rounded-full" />
            {t.hero.badge}
          </motion.span>
        </motion.div>
        
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-8 leading-tight text-accent-teal py-[10px] font-bold">
          {t.hero.title}
        </motion.h1>
        
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="text-base sm:text-lg md:text-xl text-neutral-700 mb-12 max-w-3xl mx-auto leading-relaxed py-[2px] px-4">{t.hero.subtitle}</motion.p>
        
        {/* Process Flow section with 7 steps */}
        <ProcessFlow />
        
        <motion.div className="flex flex-wrap justify-center gap-6" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.9
      }}>
          
          
        </motion.div>
        
        {/* Stats */}
        
      </div>
    </header>;
};
export default Hero;